import React, { useRef, useState } from 'react'
import { CurrencyPopover } from './CurrencyPopover'
import { HomeMenuPopover } from './HomeMenuPopover'
import { useSearchStore } from '../../../store/jpeTopPageStore'

interface HeaderCurrencyMenuProps {
  currentPath?: string
}

export const HeaderCurrencyMenu: React.FC<HeaderCurrencyMenuProps> = ({ currentPath: _currentPath = '' }) => {
  const { selectedCurrency } = useSearchStore()
  const [isCurrencyOpen, setIsCurrencyOpen] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const currencyButtonRef = useRef<HTMLButtonElement>(null)
  const menuButtonRef = useRef<HTMLButtonElement>(null)

  const handleToggleCurrencyPopover = () => {
    setIsCurrencyOpen(!isCurrencyOpen)
    if (!isCurrencyOpen) {
      setIsMenuOpen(false) // Close menu when opening currency
    }
  }

  const handleToggleMenuPopover = () => {
    setIsMenuOpen(!isMenuOpen)
    if (!isMenuOpen) {
      setIsCurrencyOpen(false) // Close currency when opening menu
    }
  }

  const handleCloseCurrency = () => {
    setIsCurrencyOpen(false)
  }

  const handleCloseMenu = () => {
    setIsMenuOpen(false)
  }

  return (
    <div className="flex items-center gap-3">
      {/* Currency Button */}
      <button
        ref={currencyButtonRef}
        onClick={handleToggleCurrencyPopover}
        className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-gray-50 transition-colors rounded-lg"
      >
        <span className="font-medium text-gray-900">{selectedCurrency}</span>
        <svg
          width="8"
          height="4"
          viewBox="0 0 8 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`transition-transform ${isCurrencyOpen ? 'rotate-180' : ''}`}
        >
          <path d="M0 0L3.75 3.75L7.5 0H0Z" fill="#111827" />
        </svg>
      </button>

      {/* Hamburger Menu Button */}
      <button ref={menuButtonRef} onClick={handleToggleMenuPopover} className="p-2 hover:bg-gray-50 transition-colors rounded-lg">
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 12H18V10H0V12ZM0 7H18V5H0V7ZM0 0V2H18V0H0Z" fill="#323232" />
        </svg>
      </button>

      {/* Currency Popover */}
      <CurrencyPopover isOpen={isCurrencyOpen} onClose={handleCloseCurrency} buttonRef={currencyButtonRef} />

      {/* Home Menu Popover */}
      <HomeMenuPopover isOpen={isMenuOpen} onClose={handleCloseMenu} buttonRef={menuButtonRef} />
    </div>
  )
}
